var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-form" },
    [
      _c("h1", { staticClass: "form-title" }, [_vm._v("Basic Information")]),
      _c("p", { staticClass: "text mt-12" }, [
        _vm._v("以下内容用中文填写即可")
      ]),
      _c("div", { staticClass: "inp-flex mt-30" }, [
        _c(
          "div",
          { staticClass: "inp-wrap" },
          [
            _c("Input", {
              attrs: { label: "First name", value: _vm.value.first_name },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "first_name")
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "inp-wrap" },
          [
            _c("Input", {
              attrs: { label: "Last name", value: _vm.value.last_name },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "last_name")
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "inp-flex mt-20" }, [
        _c(
          "div",
          { staticClass: "inp-wrap" },
          [
            _c("GenderSelect", {
              attrs: {
                label: "Gender",
                placeholder: "Gender",
                isVerific: false,
                value: _vm.value.gender
                  ? _vm.value.gender.toString()
                  : _vm.value.gender
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "gender")
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "inp-flex mt-20" }, [
        _c(
          "div",
          { staticClass: "inp-wrap" },
          [
            _c("AreaCodeSelect", {
              attrs: {
                label: "Country code",
                placeholder: "Country code",
                isVerific: false,
                value: _vm.value.phone_code
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "phone_code")
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "inp-wrap" },
          [
            _c("Input", {
              attrs: { label: "Phone number", value: _vm.value.phone },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "phone")
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "inp-flex mt-20" }, [
        _c(
          "div",
          { staticClass: "inp-wrap big" },
          [
            _c("Input", {
              attrs: { label: "Email", value: _vm.value.email },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "email")
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "inp-flex mt-20" }, [
        _c(
          "div",
          { staticClass: "inp-wrap big" },
          [
            _c("Input", {
              attrs: { label: "University", value: _vm.value.university },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "university")
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "inp-flex mt-30" }, [
        _c(
          "div",
          { staticClass: "inp-wrap" },
          [
            _c("Select", {
              attrs: {
                label: "Current grade",
                placeholder: "",
                isVerific: false,
                startVerific: false,
                value: _vm.value.grade,
                options: _vm.GRADES
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "grade")
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "inp-flex mt-20" }, [
        _c(
          "div",
          { staticClass: "inp-wrap big" },
          [
            _c("Input", {
              attrs: { label: "Current major", value: _vm.value.current_major },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "current_major")
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "inp-flex mt-20" }, [
        _c(
          "div",
          { staticClass: "inp-wrap large" },
          [
            _c("Textarea", {
              attrs: {
                placeholder: "Personal Introduction",
                counter: false,
                value: _vm.value.personal_introduction
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "personal_introduction")
                }
              }
            })
          ],
          1
        )
      ]),
      _c("p", { staticClass: "text mt-24" }, [
        _vm._v(
          " Please share details and stories including your second major if you have any, your special talent or things you do best, the organizations/departments/societies of Harvard where you take on an important role and the remarkable achievements you have made till now, the most difficult course/seminar you have ever attended at Harvard and you still got a grade A, the best off-campus internship experience you have had till now, some of your interesting hobbies, foreign languages that you can read/write/speak and any other stories that would surprise students. "
        )
      ]),
      _c("ImageUploader", {
        staticClass: "uploader-wrap mt-20",
        attrs: {
          placeholder: "Upload<br/>a profile photo",
          value: _vm.value.profile_photo,
          role: _vm.ROLES.SL
        },
        on: {
          input: function($event) {
            return _vm.handleInput($event, "profile_photo")
          }
        }
      }),
      _c(
        "div",
        { staticClass: "inp-wrap mt-20 large" },
        [
          _c("Input", {
            attrs: {
              label: "Official Seminar Title",
              value: _vm.value.seminar_title
            },
            on: {
              input: function($event) {
                return _vm.handleInput($event, "seminar_title")
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inp-wrap mt-20 large" },
        [
          _c("Textarea", {
            attrs: {
              counter: false,
              placeholder: "Official Seminar Description",
              value: _vm.value.seminar_description
            },
            on: {
              input: function($event) {
                return _vm.handleInput($event, "seminar_description")
              }
            }
          })
        ],
        1
      ),
      _vm._m(0),
      _c("CheckboxGroup", {
        staticClass: "mt-10 checkboxgroup-wrap inp-wrap large",
        attrs: { options: _vm.GROUP_OPTIONS, value: _vm.seminarTrack },
        on: {
          input: function($event) {
            return _vm.handleInputCheckGroup($event, "seminar_track")
          }
        }
      }),
      _c(
        "Button",
        { staticClass: "btn-submit", on: { click: _vm.handleClickSubmit } },
        [_vm._v("Submit")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text bold big mt-30" }, [
      _vm._v("Seminar Track "),
      _c("span", { staticClass: "weak" }, [_vm._v("Choose all that applies")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }